import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiVideo, FiBook, FiFileText, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import axios from 'axios';
import './AllClassesSessions.css';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

// Your custom alert function (make sure to add the CSS for these alerts)
const showAlert = (type, message) => {
  const alertDiv = document.createElement('div');
  
  let alertContent = '';
  if (type === 'expired') {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/>
          </svg>
        </div>
        <h3>Class Has Ended</h3>
        <p>${message}</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  } else if (type === 'early') {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
          </svg>
        </div>
        <h3>Class Not Available Yet</h3>
        <p>${message}</p>
        <p><strong>Session Duration:</strong> 50 to 60 minutes</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  } else if (type === 'issue') {
    alertContent = `
    <div class="student-dashboard-alert-content">
      <div class="student-dashboard-alert-icon">
        <svg viewBox="0 0 512 512" width="40" height="40">
          <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
        </svg>
      </div>
      <h3>Issue Report</h3>
      <p>${message}</p>
      <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
    </div>`;
  } else {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
          </svg>
        </div>
        <h3>Teacher Class Notes</h3>
        <p>${message}</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  }

  alertDiv.className = `student-dashboard-custom-alert student-dashboard-${type}-alert`;
  alertDiv.innerHTML = alertContent;
  document.body.appendChild(alertDiv);
};

const AllClassesSessions = ({ day, userData }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedClass, setExpandedClass] = useState(null);

  useEffect(() => {
    setLoading(true);  // Add this line
    fetchClasses();
  
    const intervalId = setInterval(() => {
      fetchClasses();
    }, 60000); // 60,000 ms = 1 minute
  
    return () => clearInterval(intervalId);
  }, [day, userData.id]);

  const fetchClasses = async () => {
    try {
      const formattedDay = (() => {
        const today = new Date();
        const lowercaseDay = day.toLowerCase();
        
        if (lowercaseDay === 'today') {
          // Add 3 hours to current date
          today.setHours(today.getHours() + 3);
          console.log(lowercaseDay,today.toISOString().split('T')[0]);
          return today.toISOString().split('T')[0];
        } else if (lowercaseDay === 'tomorrow') {
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          tomorrow.setHours(today.getHours() + 3); // Also add 3 hours for consistency
          console.log(lowercaseDay,tomorrow.toISOString().split('T')[0]);
          return tomorrow.toISOString().split('T')[0];
        } else if (lowercaseDay === 'yesterday') {
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          yesterday.setHours(today.getHours() + 3); // Also add 3 hours for consistency
          console.log(lowercaseDay,yesterday.toISOString().split('T')[0]);
          return yesterday.toISOString().split('T')[0];
          
        } else {
          return day; // assume it's already in YYYY-MM-DD format
        }
      })();
      
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/admin/classes/${formattedDay}`;
      const response = await axios.get(apiUrl, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` }
      });
      console.log(formattedDay);
      const formattedClasses = response.data.myClasses.map(cls => ({
        id: cls.Id,
        type: cls.Type === 0 ? 'paid' : 'demo',
        IdUser: cls.IdUser,
        studentImage: cls.image || "",
        studentName: `${cls.FirstName} ${cls.LastName}`,
        teacherName: `${cls.TFirstName} ${cls.TLastName}`,
        firstName: `${cls.FirstName}`,

        MobileNumber: cls.MobileNumber,
        StudentJoin: cls.StudentJoin,
        TeacherJoin: cls.TeacherJoin,
        classesTaken: `${cls.sessionsTaken}/${cls.totalSessions}`,
        level: cls.IdGradesPlans === 2 ? 'Junior' : cls.IdGradesPlans === 1 ? 'Little' : 'Group',
        classType: cls.Type === 0 ? 'Paid Class' : 'Demo Class',
        hasPTM: cls.sessionsTaken === cls.totalSessions? true: false,
        hasFinish: cls.sessionsTaken > cls.totalSessions? true: false,
        Awaiting: cls.Awaiting > 0? true: false,

        
        prevProject: cls.lastCourse?.CourseName || 'No previous project',
        nextProject: cls.nextCourse?.CourseName || 'No next project',
        course: cls.nextCourse?.CourseName || 'No course',
        time: new Date(cls.ClassDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        date: new Date(cls.ClassDateTime).toLocaleDateString([], { day: '2-digit', month: 'short' , year: 'numeric' }),
        classDateTime: new Date(cls.ClassDateTime),
        courseNotes: cls.coursenotes,
        lastCourseLink: cls.lastCourse?.CourseLink,
        nextCourseLink: cls.nextCourse?.CourseLink,
        projectLink: cls.lastCourse?.CourseProjectLink,
        nextprojectLink: cls.nextCourse?.CourseProjectLink,
        Issue: cls.Issue || null // Added issue field
      }));

      setClasses(formattedClasses);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
 
  function reminder(fullName, time, mobileNumber, type) {
    const templates = [
      (name, t) =>
        `Hi ${name}! Just a kind Reminder that Your Session is Today at ${t}. We're excited to see you! 🚀 Robomind Team`,
      (name, t) =>
        `Hello ${name}, Your Coding Session is Scheduled for ${t}. Get ready to learn and have fun! 🚀 Robomind Team`,
      (name, t) =>
        `Hey ${name}! Don't Forget Your Class at ${t} today. Let’s build something awesome together! 🚀 Robomind Team`,
      (name, t) =>
        `Dear ${name}, This is a Friendly Reminder for Your Session at ${t}. Looking forward to another great lesson! 🚀 Robomind Team`,
      (name, t) =>
        `Hi ${name}, Hope you're doing Great! Your session is Today at ${t}. Let's code and have fun! 🚀 Robomind Team`
    ];
  
    let messages = [];
  
    if (type === 0) {
      for (let i = 1; i <= 5; i++) {
        const randomTemplate =
          templates[Math.floor(Math.random() * templates.length)];
        messages.push(randomTemplate(fullName, time));
      }
    } else if (type === 1) {
      messages.push(
        `Hello ${fullName}, Your Session Has Already Started. We're Waiting for You to Join! 🚀 Robomind Team`
      );
    }
  
    messages.forEach((msg, index) => {
      setTimeout(() => {
        const encodedMsg = encodeURIComponent(msg);
        const phone = mobileNumber.replace(/\D/g, "");
        const url = `https://wa.me/${phone}?text=${encodedMsg}`;
        window.open(url, "_blank");
      }, index * 1000);
    });
  }
  
  
  const handleViewNotes = (notes) => {
    if (notes && notes.trim() !== '') {
      showAlert('info', notes);
    } else {
      showAlert('info', 'No notes available for this class.');
    }
  };

  const handleJoinClass = async (classId) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/classes/check-availability`, {
        classId
      },        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
);
  
      const { status, message, zoomUrl } = response.data;
  
      if (status === 'expired') {
        showAlert('expired', message);
        return;
      }
  
      if (status === 'early') {
        showAlert('early', message);
        return;
      }
  
      if (status === 'joining') {
        window.open(zoomUrl, '_blank');
      }
    } catch (error) {
      console.error('Error:', error);
      showAlert('error', 'An error occurred. Please try again.');
    }
  };

  const toggleExpand = (id) => {
    setExpandedClass(expandedClass === id ? null : id);
  };

  const isReportSectionActive = (classDateTime) => {
    const now = new Date();
    const classEndTime = new Date(classDateTime);
    classEndTime.setHours(classEndTime.getHours() + 1); // Add 1 hour to class time
    
    return now >= classDateTime && now <= classEndTime;
  };

  const handleSubmitIssue = async (classId, issueType) => {
  
    try {
      const submissionData = {
        IdSchedule: classId,
        IdIssue: issueType
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/teacher/submitissue`,
        submissionData,        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }

      );
  
      if (response.status === 200) {
        showAlert('issue', 'Report Submitted');
        await fetchClasses();
      } else {
        showAlert('issue', 'Failed to submit issue. Please try again.');
      }
  
    } catch (error) {
      console.error('Error submitting issue:', error);
      showAlert('issue', 'An error occurred while submitting the issue.');
    }
  };
  if (loading) {
    return (
      <div className="pending-loading">
        <div className="spinner"></div>
        <p>Loading Your Classes...</p>
      </div>
    );
  }

  if (error) {
    return <div className="classes-container">Error: {error}</div>;
  }

  
  
  return (
    <div className="classes-container">

      {classes.length === 0 ? (
        <div className="no-classes">No classes scheduled for this day</div>
      ) : (
        <div className="classes-list">
          {classes.map((cls) => (
              <div 
                key={cls.id} 
                className={`class-card ${cls.type} ${expandedClass === cls.id ? 'expanded' : ''}`}
                onMouseEnter={() => toggleExpand(cls.id)}
                onMouseLeave={() => setExpandedClass(null)}
              >
              <div className="class-main-info">
                <div className="student-info">
                  <img src={cls.studentImage} alt={cls.studentName} className="student-avatar shadow" />
                  <div className="student-details">
                    <h4 className="student-name">{cls.studentName}{" "}
                    
                    <a 
                      href={`studentprofile/${cls.IdUser}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="student-profile-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <svg 
                        viewBox="0 0 24 24" 
                        width="18" 
                        height="18" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                    <span className={`classes-taken ${cls.Awaiting ? 'text-red' : ''}`}> {cls.type === "demo" ? "" : cls.Awaiting ? 'Awaiting Payment' : ``}</span>
                  </h4>
                  <p CourseName="text-lightgrey">Teacher: {cls.teacherName} </p>
                    <div className={`classes-taken ${cls.hasPTM ? 'text-red' : ''}`}>
                      {cls.type === "demo" ? "" : cls.hasFinish ? 'Awaiting Updates' : `Class Nb: ${cls.classesTaken}`}
                      

                    </div>
                                       
                    <div className="badges-container">
                      <span className={`badge type ${cls.type}`}>{cls.classType}</span>
                      <span className={`badge level ${cls.level.toLowerCase()}`}>{cls.level}</span>
                      {cls.hasPTM && cls.type === "paid" && <span className="badge ptm">PTM</span>}
                    </div>
                  </div>
                </div>
                
               
                
                <div className="class-time">
                <div>{cls.date} {cls.time} </div>
                  
                </div>

                <div className=" class-time2">
                      <div className={`badge1 level ${cls.TeacherJoin ? 'ptm' : 'junior'}`}>
                      {cls.TeacherJoin
                          ? `TJ: ${new Date(cls.TeacherJoin).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}`
                          : 'Teacher Not Joined'}
                      </div>
                      <div className={`badge1 level ${cls.StudentJoin ? 'ptm' : 'junior'}`}>
                        {cls.StudentJoin
                          ? `SJ: ${new Date(cls.StudentJoin).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}`
                          : 'Student Not Joined'}
                      </div>
                      
                      
                </div> 
                <div className="class-time">
                <button 
                    className="join-btn"
                    onClick={(e) => {
                    e.stopPropagation();
                    handleJoinClass(cls.id);
                    }}
                  >
                    Join Class <FiChevronRight />
                  </button>
                </div> 
              </div>
              <div className="projects-container">
              {cls.type === "paid"?(
                <>
                  <div className="project-section">
                    <div className="project-label">Prev Project:
                    <span className="project-title"> {cls.prevProject}</span></div>
                    <div className="project-buttons">
                      {cls.lastCourseLink && (
                        <a href={cls.lastCourseLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                          <FiVideo /> Project
                        </a>
                      )}
                      {cls.projectLink && (
                        <a href={cls.projectLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                         <FiBook /> Course
                        </a>
                      )}
                      
                      {cls.lastCourseLink && cls.courseNotes && (
                        <button 
                          className="project-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewNotes(cls.courseNotes);
                          }}
                        >
                          <FiFileText /> Note
                        </button>
                      )}
                    </div>
                  </div>
                  
                  <div className="project-section">
                    <div className="project-label">Next Project:
                    <span className="project-title"> {cls.nextProject}</span></div>
                    <div className="project-buttons">
                      {cls.nextCourseLink && (
                        <a href={cls.nextCourseLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                          <FiVideo /> Project
                        </a>
                      )}
                      {cls.nextprojectLink && (
                        <a href={cls.nextprojectLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                         <FiBook /> Course
                        </a>
                      )}
                    </div>
                  </div>
                  </>
                  ):(
                    <>
                     <div className="project-section">
                    <div className="project-label">Projects:
                    <span className="project-title"> Demo Projects</span></div>
                    <div className="project-buttons">
                      
                      
                    </div>
                   
                  </div>
                  
                  <div className="project-section">
                    
                  </div>
                    </>

                  )}
                 <div className="project-section class-time1">
                  

                  

                  <button 
                    className="join-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      const phone = cls.MobileNumber.replace(/\D/g, ""); // remove any symbols
                      window.open(`https://wa.me/${phone}`, "_blank");
                    }}
                  >
                    WhatsApp <faWhatsapp />
                  </button>
                  <button 
                    className="join-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      reminder(cls.firstName, cls.time, cls.MobileNumber, 1);
                    }}
                  >
                    Rem Late <faWhatsapp />
                  </button>
                  <button 
                    className="join-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      reminder(cls.firstName, cls.time, cls.MobileNumber, 0);
                    }}
                  >
                    Rem Before <faWhatsapp />
                  </button>
                  
                </div>
                  
                </div>




                <div className={`report-section ${expandedClass === cls.id ? 'open' : ''}`}>
                <div className="report-title">Report Issue:</div>
                <div className="report-buttons">
                  <button 
                    className={`report-btn ${cls.Issue === 1 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 1)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiAlertCircle /> Student Not Joined
                  </button>
                  <button 
                    className={`report-btn ${cls.Issue === 2 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 2)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiAlertCircle /> Student Left
                  </button>
                  <button 
                    className={`report-btn ${cls.Issue === 3 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 3)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiAlertCircle /> Internet Issue
                  </button>
                  <button 
                    className={`report-btn ${cls.Issue === 4 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 4)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiAlertCircle /> Mic/Audio Issue
                  </button>
                  <button 
                    className={`report-btn ${cls.Issue === 5 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 5)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiAlertCircle /> Zoom Link Issue
                  </button>
                  <button 
                    className={`report-btn resolved ${cls.Issue === 0 ? 'resolvedyes' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 0)}
                    disabled={!isReportSectionActive(cls.classDateTime)}
                  >
                    <FiCheckCircle /> Issue Resolved
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllClassesSessions;